<template>
  <div class="flex flew-row">
    <NumericInput
      :value="localHeightInCm"
      min="0"
      max="270"
      aria-label="cm"
      inputId="heightMajor"
      :input-style="inputStyle"
      :measurement-indicator="measurementIndicators.centimeters"
      :disabled="disabled"
      @input="localHeightInCm = $event"
      @blur="$emit('blur')"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { validateInput } from "../../SimpleBmiQuestion/validation";
import { ImperialHeightMeasurementIndicators, MetricHeightMeasurementIndicators } from "../../../types";
import NumericInput from "./NumericInput.vue";

export default Vue.extend({
  components: { NumericInput },
  props: {
    heightInCm: { type: Number, required: true },
    inputStyle: { type: String, required: true },
    measurementIndicators: { type: Object as PropType<MetricHeightMeasurementIndicators>, required: true },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    localHeightInCm: {
      get() {
        return this.heightInCm;
      },
      set(value) {
        const emitValue = validateInput(value, 270);
        this.$emit("update:heightInCm", emitValue);
      },
    },
  },
});
</script>
